<template>
  <div class="weeklyReportDetailView_detail">

      <div 
        v-for="(weeklyReportDetailItem,i) in weeklyReportDetailListByDay"
        :key="weeklyReportDetailItem.id">
      <div class="weeklyBox boxLine"
       v-if="weeklyReportDetailItem.weeklyReportItem_Project.length >0 || weeklyReportDetailItem.weeklyReportItem_Task.length >0">
        <!-- <div class="weeklyBoxDate">
          <span :class="i==5||i==6?'redTitle':''">
            {{weeklyReportDetailItem.currentDay|currentTimeShow}}
          </span>
          <span style="float: right;margin-right: 9%;"
            v-if="weeklyReportDetailItem.totalTime">
            总计工时：{{weeklyReportDetailItem.totalTime}}
            </span>
        </div> -->
        <div v-if="weeklyReportDetailItem.weeklyReportItem_Project.length >0 || weeklyReportDetailItem.weeklyReportItem_Task.length >0">
          <table border="0" width="100%">
              <tr>
                   <td style="vertical-align:top;width:90px;"> 
                     <div class="dayDateArea">
                        <div :class="i==5||i==6?'redTitle':''" style="text-align:center;">
                            <span>{{weeklyReportDetailItem.currentDay|currentDateFilter}}</span>
                        </div>
                        <div :class="i==5||i==6?'redTitle':''" style="text-align:center;margin-top:10px;">
                            <span>{{weeklyReportDetailItem.currentDay|currentDayFilter}}</span>
                        </div>
                     </div>

                     <div class="weeklyBoxDate" v-if="weeklyReportDetailItem.totalTime">
                      <span>总工时：</span>
                      <span>{{weeklyReportDetailItem.totalTime}}</span>
                    </div>
                </td>
                  <td>
                       <table v-if="weeklyReportDetailItem.weeklyReportItem_Project.length >0" border="0" cellspacing="0" cellpadding="2" class="weeklyReportTable">
                        <tbody>
                          <tr style="font-weight:bold">
                            <td width="20%" class="td_weeklyReportPost">项目</td>
                            <td width="20%" class="td_weeklyReportPost">任务类别</td>
                            <td class="td_weeklyReportPost">工作内容</td>
                            <td width="7%" class="td_weeklyReportPost">工时</td>
                          </tr>
                          <tr v-for="(projectItem,projectIndex) in weeklyReportDetailItem.weeklyReportItem_Project"
                            :key="projectIndex">
                            <td class="td_weeklyReportPost">
                              <el-input v-model="projectItem.projectName" disabled></el-input>
                            </td>
                            <td class="td_weeklyReportPost">
                              <el-input v-model="projectItem.projectTaskName" disabled></el-input>
                            </td>
                            <td class="td_weeklyReportPost">
                              <el-input type="textarea" v-model="projectItem.content" disabled></el-input>
                            </td>
                            <td class="td_weeklyReportPost">
                              <el-input v-model="projectItem.spentTime" disabled></el-input>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-if="weeklyReportDetailItem.weeklyReportItem_Task.length >0">
                          <table border="0" cellspacing="0" cellpadding="2" class="weeklyReportTable">
                                      <tbody>
                                        <tr style="font-weight:bold">
                                          <td width="40%" class="td_weeklyReportPost">日常工作</td>
                                          <td class="td_weeklyReportPost">工作内容</td>
                                          <td width="7%" class="td_weeklyReportPost">工时</td>
                                        </tr>

                                        <tr v-for="(taskItem,taskIndex) in weeklyReportDetailItem.weeklyReportItem_Task"
                                          :key="taskIndex">
                                          <td class="td_weeklyReportPost">
                                            <el-input v-model="taskItem.taskName" disabled></el-input>
                                          </td>
                                          <td class="td_weeklyReportPost">
                                            <el-input type="textarea" v-model="taskItem.content" disabled></el-input>
                                          </td>

                                          <!-- <td class="td_weeklyReportPost">
                                            <el-form :model="taskItem" :rules="rules" ref="ruleForm" @submit.native.prevent>
                                              <el-form-item label=" " prop="spentTime">
                                                <el-input v-model="taskItem.spentTime" @change="spentTimeChange(taskItem)"></el-input>
                                              </el-form-item>
                                            </el-form>
                                            <el-input type="textarea" v-model="taskItem.content" disabled></el-input>
                                          </td>-->

                                          <td class="td_weeklyReportPost">
                                            <el-input v-model="taskItem.spentTime" disabled></el-input>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                      </div>
                  </td>
              </tr>
          </table>
          
         
        </div>
        
      </div>
      </div>
  </div>
</template>

<script>
import { dateFtt } from "@/utils/auth.js";
export default {
  name: "weeklyReportView_Detail",
  props: ["getWeeklyReportByUserArgs"],
  data() {
    return {
      // 记录每周周报的id和备注信息
      weeklyReportForm: {
        id: "",
        description: "",
        attachedFiles:[]
      },
      //因为在周报视图要按天输出，这里是按天组织过的数据
      weeklyReportDetailListByDay: [
        {
          weeklyReportItem_Task: [
            {
              // id:null,
              // weeklyReportId:null,
              taskId: "",
              content: "",
              date: "",
              spentTime: "",
              numericalOrder: 1,
              projectTypeName: "",
              projectName: ""
            }
          ],
          weeklyReportItem_Project: [
            {
              // id:null,
              // weeklyReportId:null,
              projectId: "",
              content: "",
              date: "",
              spentTime: "",
              numericalOrder: 1
            }
          ],
          currentDay: ""
        }
      ]
    };
  },
  filters: {
    // currentTimeShow: function(value) {
    //   return dateFtt("yyyy年MM月dd日 EEE ", new Date(value));
    // }
    currentDateFilter: function(value) {
      // return dateFtt("yyyy年MM月dd日 EEE ", value);
       return dateFtt("MM月dd日", value);
    },
    currentDayFilter: function(value) {
      // return dateFtt("yyyy年MM月dd日 EEE ", value);
       return dateFtt("EEE", value);
    }
  },
  methods: {

    clearData(){
        this.weeklyReportForm.id = "";
        this.weeklyReportForm.description = "";
        this.weeklyReportForm.attachedFiles = [];

        this.createWeeklyReportDailyDataArray([]);
    },
    
    //data是服务端返回的原始周报数据
    loadWeeklyReportData(data) {
  //    this.weeklyReportDetailListByDay = [];
      if (data == null) 
      {
        this.weeklyReportForm.id = "";
        this.weeklyReportForm.description = "";
        this.weeklyReportForm.attachedFiles = [];

        this.createWeeklyReportDailyDataArray([]);
        return;
      } 
      else 
      {
        this.weeklyReportForm.id = data.id;
        this.weeklyReportForm.description = data.description;
        this.weeklyReportForm.attachedFiles = data.attachedFiles;

        this.weeklyReportForm.monday = data.monday;
        let viewData = this.convertServerDataToViewData(data);
        this.createWeeklyReportDailyDataArray(this.computeTotalTime(viewData));
      }
    },
   
    //周报视图按照日期格式从星期一到星期天展示
    //对视图对象进一步加工，确保每一天都有完整的对象
    createWeeklyReportDailyDataArray(dataArray) 
    {
      let startTime = new Date(this.weeklyReportForm.monday);
      this.weeklyReportDetailListByDay = [];
      if (dataArray.length == 0) 
      {
        for (var i = 0; i < 7; i++) 
        {
          let currentTime = dateFtt(
            "yyyy/MM/dd hh:mm:ss",
            startTime.getTime() + 24 * 60 * 60 * 1000 * i
          );
          this.weeklyReportDetailListByDay.push
          ({
            weeklyReportItem_Task: [],
            weeklyReportItem_Project: [],
            currentDay: currentTime
          });
        }
      } 
      else 
      {
        for (var j = 0; j < 7; j++) 
        {
          let currentTime = dateFtt(
            "yyyy/MM/dd hh:mm:ss",
            startTime.getTime() + 24 * 60 * 60 * 1000 * j
          );
          let isExist = false;
          dataArray.forEach(item => 
          {
            if (item.currentDay == currentTime) 
            {
              isExist = true;
              if (!item.weeklyReportItem_Task) 
              {
                item.weeklyReportItem_Task = [];
              }
              if (!item.weeklyReportItem_Project) 
              {
                item.weeklyReportItem_Project = [];
              }
              this.weeklyReportDetailListByDay.push(item);
            }
          });
          if (!isExist) 
          {
            this.weeklyReportDetailListByDay.push
            ({
              weeklyReportItem_Task: [],
              weeklyReportItem_Project: [],
              currentDay: currentTime
            });
          }
        }
      }
    },

    //服务端数据转化为周报视图数据
    //这里得到的数据，有可能并不包含 每一天 的对象
    //只单纯的把既有数据转成视图格式
    convertServerDataToViewData(serverData) 
    {
      let viewData = [];
      let weeklyReportItem_Task = serverData.weeklyReportItem_Task || [];
      let weeklyReportItem_Project = serverData.weeklyReportItem_Project || [];
      
      if (weeklyReportItem_Task.length != 0) 
      {
        weeklyReportItem_Task.forEach(taskItem => 
        {
          if (
            (taskItem.spentTime == 0 || taskItem.spentTime == "" || taskItem.spentTime == null) 
              &&taskItem.content == ""
          )
            return;

          if (viewData.length == 0) 
          {
            viewData.push
            (
              {
              weeklyReportItem_Task: [taskItem],
              currentDay: taskItem.date
            });
          } else {
            let isItemExist = false;
            viewData.forEach(weeklyReportItem => 
            {
              if (weeklyReportItem.currentDay === taskItem.date) 
              {
                isItemExist = true;
                weeklyReportItem.weeklyReportItem_Task.push(taskItem);
              }
            });
            if (!isItemExist) {
              let taskObj = {
                weeklyReportItem_Task: [taskItem],
                currentDay: taskItem.date
              };
              // taskObj.weeklyReportItem_Task.push(taskItem);
              viewData.push(taskObj);
            }
          }
        });
      }
      if (weeklyReportItem_Project.length != 0) {
        weeklyReportItem_Project.forEach(
          projectItem => {
            if (
              (projectItem.spentTime == 0 ||
                projectItem.spentTime == "" ||
                projectItem.spentTime == null) &&
              projectItem.content == ""
            )
              return;
            if (viewData.length == 0) 
            {
              viewData.push
              (
                {
                weeklyReportItem_Project: [projectItem],
                currentDay: projectItem.date
              });
            } else {
              let isExist = false;
              viewData.forEach(weeklyReportItem => 
              {
                if (weeklyReportItem.currentDay === projectItem.date) 
                {
                  isExist = true;
                  if (weeklyReportItem.weeklyReportItem_Project) 
                  {
                    weeklyReportItem.weeklyReportItem_Project.push(
                      projectItem
                    );
                  } else {
                    weeklyReportItem.weeklyReportItem_Project = [];
                    weeklyReportItem.weeklyReportItem_Project.push(projectItem);
                  }
                }
              });
              if (!isExist) {
                let dataObj = {
                  weeklyReportItem_Project: [
                    projectItem
                  ],
                  currentDay: projectItem.date
                };
                // dataObj.weeklyReportItem_Project.push(item);
                viewData.push(dataObj);
              }
            }
          }
        );
      }
      return viewData;
    },
    //周报视图计算总工时
    computeTotalTime(viewData) {
      if (viewData.length == 0) 
        return [];
      viewData.forEach(item => {
        let sum = 0;
        if (item.weeklyReportItem_Task) {
          item.weeklyReportItem_Task.forEach(taskItem => {
            sum += Number(taskItem.spentTime);
          });
        }
        if (item.weeklyReportItem_Project) {
          item.weeklyReportItem_Project.forEach(projectItem => {
            sum += Number(projectItem.spentTime);
          });
        }
        item.totalTime = sum;
      });
      return viewData;
    },

  }
};
</script>

<style  rel="stylesheet/scss" lang="scss">
.weeklyReportDetailView_detail {
  
  font-size: 14px;

  .dayDateArea
  {
    width: 80px;
    padding: 10px;
    border: solid 1px rgb(197, 216, 238);
    background-color: rgb(247, 247, 232);
    font-size: 12px;
  }

  .weeklyBox {
  margin-top: 0px;
    margin-bottom: 10px;
    padding: 20px;
    padding-right: 0;
  }
  .weeklyBoxTitle {
    float: left;
    width: 3%;
    color: #44739d;
    font-size: 14px;
    writing-mode: vertical-rl;
    /* text-align: right; */
    padding-right: 10px;
  }
  .weeklyBoxDate {
     font-size: 12px;
    margin-top: 20px;
    margin-left:5px;
  }
  .weeklyReportTable {
    width: 100%;
    min-height: 100px;
    .td_weeklyReportPost {
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: top;
    }
    .el-input__inner,
    .el-input__icon,
    .el-form-item__content {
      height: 30px;
      line-height: 30px;
    }

    .el-input__inner,
    .el-textarea__inner {
      border: none !important;
      border-radius: 0 !important;
      padding: 0;
    }
    .el-textarea__inner {
      /* height: 60px; */
      padding-top: 5px;
      color: #606266;
      font-size: inherit;
    }
    // .el-input.el-input--suffix,
    // .el-input,
    // .el-textarea {
    //   border-bottom: 1px solid #bbbbbb;
    // }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/common/weeklyReportView_Detail.vue